// @flow
import styles from './SignedInDashboard.less';

import { connect } from 'react-redux';
import classnames from 'classnames';
import React, { PureComponent } from 'react';

import { Hidden } from 'seek-style-guide/react';
import SavedSearchesDashboard from './SavedSearchesDashboard/SavedSearchesDashboard';
import SavedJobsDashboard from './SavedJobsDashboard/SavedJobsDashboard';
import RecommendedJobsDashboard from './RecommendedJobsDashboard/RecommendedJobsDashboard';
import DashboardError from './DashboardError/DashboardError';

const mapStateToProps = ({ dashboard }) => ({
  ready: dashboard.ready,
  error: dashboard.error,
  expand: dashboard.expand
});

type Props = {
  ready: boolean,
  error: boolean,
  expand: boolean
};
class SignedInDashboard extends PureComponent<Props> {
  props: Props;

  render() {
    const { ready, error, expand } = this.props;

    return (
      <div
        data-automation="signedInDashboard"
        className={classnames({
          [styles.root]: true,
          [styles.root_isReady]: ready,
          [styles.root_isExpanded]: expand
        })}
      >
        {error ? (
          <DashboardError />
        ) : (
          <div
            className={styles.content}
            data-automation="signedInDashboardContent"
          >
            <div className={styles.contentInner}>
              <SavedSearchesDashboard />
            </div>

            <Hidden mobile className={styles.divider} />

            <div className={styles.contentInner}>
              <SavedJobsDashboard />
            </div>

            <Hidden mobile className={styles.divider} />

            <div className={styles.contentInner}>
              <RecommendedJobsDashboard />
            </div>
          </div>
        )}
        <div className={styles.backdrop} />
      </div>
    );
  }
}
export default connect(mapStateToProps)(SignedInDashboard);
